import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';
import { FIREBASE_CONFIG } from './environmentVariables';

firebase.initializeApp(FIREBASE_CONFIG);

if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  console.log('[EnforcePlus] Connecting to Firebase Emulators');
  firebase.auth().useEmulator('http://localhost:9099', { disableWarnings: true });
  firebase.firestore().useEmulator('localhost', 8080);
  firebase.functions().useEmulator('localhost', 5001);
  firebase.storage().useEmulator('localhost', 9199);
}

export default firebase;
